import * as React from 'react';
import { useState } from 'react';
import '../css/collapsible-panel.sass';

interface CollapsiblePanelWrapperProps {
  children: React.ReactElement[];
}

interface ImageState {
  imageSource: string;
  imageAlt: string;
}

export default function CollapsiblePanelGroup(
  props: CollapsiblePanelWrapperProps
) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [activeIndex, setActiveIndex] = useState(0);

  const [activeImage, setActiveImage] = React.useState<ImageState>({
    imageSource: '',
    imageAlt: ''
  });

  const updateActiveIndex = (index: number, image: ImageState) => {
    setActiveIndex(index);
    setActiveImage(image);
  };

  return (
    <div className="row collapsible-panel-group">
      <div className="col-md-6">
        {props.children.map((value, i) => {
          return React.cloneElement(value, {
            onChange: (index: number, newImage: ImageState) => {
              updateActiveIndex(index, newImage);
            },
            index: i,
            activeIndex
          });
        })}
      </div>
      <div className="col-md-6 collapsible-image-container">
        <img
          src={activeImage.imageSource}
          alt={activeImage.imageAlt}
          className="collapsible-image"
        ></img>
      </div>
    </div>
  );
}
